/**
 * Configuration client (URL API, etc.)
 */
/** En dev, URL relative → proxy Vite vers le serveur (évite les soucis de port / CORS). */
const API_BASE =
  typeof import.meta.env?.VITE_API_URL === 'string' && import.meta.env.VITE_API_URL.length > 0
    ? import.meta.env.VITE_API_URL
    : '';

export { API_BASE };
